/* tslint:disable */
/* eslint-disable */
/**
 * TOM ADMIN SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const ContainerType = {
    Unknown: 'Unknown',
    General: 'General',
    GeneralVentilated: 'GeneralVentilated',
    ReeferRefrigerated: 'ReeferRefrigerated',
    OpenTop: 'OpenTop',
    PlatformWithIncompleteSuperstructure: 'PlatformWithIncompleteSuperstructure',
    TankPressurizedLiquid: 'TankPressurizedLiquid',
    Bulk: 'Bulk',
    Foldable: 'Foldable',
    AirSurface: 'AirSurface',
    Livestock: 'Livestock',
    Auto: 'Auto',
    Fish: 'Fish',
    NonCargoCarrying: 'NonCargoCarrying',
    ReeferRefrigeratedAndHeated: 'ReeferRefrigeratedAndHeated',
    ReeferSelfPowered: 'ReeferSelfPowered',
    ReeferIntegratedMachinery: 'ReeferIntegratedMachinery',
    ReeferHeated: 'ReeferHeated',
    ReeferRefrigeratedOrHeatedWithIntegratedEquipment: 'ReeferRefrigeratedOrHeatedWithIntegratedEquipment',
    ReeferInsulated: 'ReeferInsulated',
    ReeferEutectic: 'ReeferEutectic',
    PlatformFixed: 'PlatformFixed',
    PlatformCollapsible: 'PlatformCollapsible',
    PlatformWithCompleteSuperstructure: 'PlatformWithCompleteSuperstructure',
    PlatformNamedCargo: 'PlatformNamedCargo',
    TankPressurizedOrNonPressurizedDry: 'TankPressurizedOrNonPressurizedDry',
    NamedCargo: 'NamedCargo',
} as const;

export type ContainerType = typeof ContainerType[keyof typeof ContainerType];



